<template>
  <section class="advices band" aria-labelledby="advices-title">
    <div class="container">
      <h2 id="advices-title">Ce qu'en disent les clients</h2>
      <p class="muted intro">Avis laissés sur Google par des clients de Citron Digital pour la création de leur site.</p>
      <ul class="advices-list">
        <li v-for="advice in advices" :key="advice.username">
          <figure>
            <div class="stars" role="img" :aria-label="advice.stars + ' étoiles sur 5'">
              <img v-for="n in advice.stars" :key="'on' + n" src="/img/yellow_star.svg" width="18" height="18" alt="" loading="lazy">
              <img v-for="n in 5 - advice.stars" :key="'off' + n" src="/img/blank_star.svg" width="18" height="18" alt="" loading="lazy">
            </div>
            <blockquote>
              <p v-for="(paragraph, index) in advice.description.split('\n')" :key="index">{{ paragraph }}</p>
            </blockquote>
            <figcaption>
              <strong>{{ advice.username }}</strong>
              <time :datetime="advice.iso">{{ advice.date }}</time>
              <img src="/img/google.svg" width="20" height="20" alt="Avis Google" loading="lazy">
            </figcaption>
          </figure>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AdvicesComponent',
  data: function () {
    return {
      advices: [
        {
          username: "OufleureCrea",
          date: "01/03/2025",
          iso: "2025-03-01",
          stars: 5,
          description: "J’ai fait appel à Citron Digital pour créer mon site web et j’en suis très satisfaite. Le travail a été réalisé rapidement, avec une communication claire du début à la fin. Il s’est occupé du nom de domaine et de l’hébergement, tout en s’adaptant parfaitement à mon budget. \nProfessionnel compétent avec une solide expertise technique, Franck Besson saura répondre à vos besoins avec efficacité. Si vous cherchez quelqu’un de confiance à qui confier votre projet (votre “bébé”), vous êtes à la bonne adresse. Vous pouvez compter sur son sérieux, son savoir-faire et son engagement."
        }, {
          username: "Ouzahra Halima",
          date: "11/02/2025",
          iso: "2025-02-11",
          stars: 5,
          description: "Il m’a aidée à développer ma boutique en ligne sur WordPress avec professionnalisme et expertise. Grâce à son intervention, la performance de mon site s’est nettement améliorée, tout comme son référencement naturel (SEO). Il m’a également accompagnée dans le changement de nom de domaine en s’occupant de tout avec rigueur. Très compétent, je ne regrette absolument pas notre collaboration et le recommande vivement !"
        }
      ],
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~/src/common/style/constants.styl';

  .advices
    background WHITE
    border-top 1px solid RULE
    border-bottom 1px solid RULE
    h2
      margin 0 0 8px
    .intro
      margin 0 0 32px

  .advices-list
    list-style none
    margin 0
    padding 0
    display grid
    gap 24px
    li
      margin 0
      padding 0

  figure
    margin 0
    height 100%
    padding 24px
    background PAPER
    border 1px solid RULE
    border-radius 6px

  .stars
    display flex
    gap 2px
    margin-bottom 12px

  blockquote
    margin 0
    p
      margin 0
      font-size 0.98rem
      line-height 1.6
      color INK_SOFT
    p + p
      margin-top 0.7em

  figcaption
    display flex
    align-items center
    flex-wrap wrap
    gap 4px 12px
    margin-top 16px
    font-size 0.92rem
    color MUTED
    strong
      color INK
    img
      margin-left auto

  @media (min-width: DESKTOP_SIZE)
    .advices-list
      grid-template-columns 1fr 1fr
</style>
